export default __webpack_public_path__ + "static/media/hh500x696.d942b009.png";